import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';
import { ResourceItem } from '@klickdata/core/resource-item';

@Component({
    selector: 'app-resource-details-scorm',
    templateUrl: './resource-details-scorm.component.html',
    styleUrls: ['./resource-details-scorm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsScormComponent extends ResourceDetailsBaseComponent {
    constructor() {
        super();
    }
    public get resourceIsAvailable(): boolean {
        return this.resource.prompt_status != 'ERROR';
    }
    public onItemClick(item: ResourceItem) {
        this.infoComp.takeResource(this.resource, this.user, new ResourceItem({ play_position: item.entry_url }));
    }
}
